import styled from 'styled-components';

const LandingPage = styled.div`
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  background-color: var(--color-bg-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;

  padding-top: 10vh;
  font-family: Inter, 'Montserrat', sans-serif !important;
  color: var(--color-bg-primary);
  background-size: cover;
`;

export default LandingPage;
